import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { EmailAuthContext } from "../../../core/common/context/EmailAuthContext";
import { useSelector } from "react-redux";
import api from "../../../core/axios/axiosInstance";
const route = all_routes;
const SyncAndIntegration = () => {
  const [modalText, setModalText] = useState("");
  const [metaLeadForms, setMetaLeadForms] = useState([]);
  const [loadingForms, setLoadingForms] = useState(false);
  const [setupHighlight, setSetupHighlight] = useState(null); // "email" | "crm" | null
  const location = useLocation();

  // Two-step form states
  const [modalStep, setModalStep] = useState(1); // 1 = form list, 2 = import options
  const [selectedForm, setSelectedForm] = useState(null);
  const [importType, setImportType] = useState("my_account"); // "my_account" or "agent_account"
  const [selectedAgent, setSelectedAgent] = useState("");
  const [agents, setAgents] = useState([]);
  const [loadingAgents, setLoadingAgents] = useState(false);
  const iconMap = {
    google: "icons/googleLogo.png",
    microsoft: "icons/microsoftLogo.png",
    smtp: "icons/smtpLogo.png",
    zoho: "icons/zohoCrmLogo.png",
    meta: "icons/facebookIcon.png",
    zoom: "customIcons/zoomIcon.png",
    hubspot: "customIcons/hubspotLogo.png",
    pipedrive: "customIcons/pipedriveLogo.png",
  };
  const {
    googleSignIn,
    googleSignOut,
    microsoftSignIn,
    microsoftSignOut,
    smtpSignIn,
    smtpSignOut,
    zohoSignIn,
    zohoSignOut,
    metaSignIn,
    metaSignOut,
    zoomSignIn,
    zoomSignOut,
    hubspotSignIn,
    hubspotSignOut,
    pipedriveSignIn,
    pipedriveSignOut,
    selectMetaPage,
    subscribeToMetaPage,
    fetchMetaPages: fetchMetaPagesFromContext,
  } = useContext(EmailAuthContext);
  const userProfile = useSelector((state) => state.profile);

  const [formData, setFormData] = useState({
    SMTP_HOST: "",
    SMTP_PORT: "",
    SMTP_USER: "",
    SMTP_PASS: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const onGoogleDisconnect = () => {
    googleSignOut();
  };
  const onMicrosoftDisconnect = () => {
    microsoftSignOut();
  };
  const onSmtpDisconnect = () => {
    smtpSignOut();
  };
  const onZohoDisconnect = () => {
    zohoSignOut();
  };
  const onMetaDisconnect = () => {
    metaSignOut();
  };
  const onZoomDisconnect = () => {
    zoomSignOut();
  };
  const onHubSpotDisconnect = () => {
    hubspotSignOut();
  };
  const onPipedriveDisconnect = () => pipedriveSignOut();
  const toggleHandlers = (account) => {
    if (account.type === "google") {
      if (account.isConnected) {
        setModalText("Google");
        document.getElementById("open-disconnect-modal").click();
      } else {
        googleSignIn();
      }
    }
    if (account.type === "microsoft") {
      if (account.isConnected) {
        setModalText("Microsoft");
        document.getElementById("open-disconnect-modal").click();
      } else {
        microsoftSignIn();
      }
    }
    if (account.type === "smtp") {
      if (account.isConnected) {
        setModalText("SMTP");
        document.getElementById("open-disconnect-modal").click();
      } else {
        document.getElementById("open-smtp-modal").click();
      }
    }
    if (account.type === "zoho") {

      if (account.isConnected) {
        setModalText("Zoho");
        document.getElementById("open-disconnect-modal").click();
      } else {
        zohoSignIn();
      }
    }
    if (account.type === "meta") {
      if (account.isConnected) {
        setModalText("Meta");
        document.getElementById("open-disconnect-modal").click();
      } else {
        metaSignIn();
      }
    }
    if (account.type === "zoom") {
      if (account.isConnected) {
        setModalText("Zoom");
        document.getElementById("open-disconnect-modal").click();
      } else {
        zoomSignIn();
      }
    }
    if (account.type === "HubSpot") {
      if (account.isConnected) {
        setModalText("HubSpot");
        document.getElementById("open-disconnect-modal").click();
      } else {
        hubspotSignIn();
      }
    }
    if (account.type === "pipedrive") {
      if (account.isConnected) {
        setModalText("Pipedrive");
        document.getElementById("open-disconnect-modal").click();
      } else {
        pipedriveSignIn();
      }
    }
  };

  const fetchMetaPages = async () => {
    setLoadingForms(true);
    try {
      const leadForms = await fetchMetaPagesFromContext();
      setMetaLeadForms(leadForms);
    } catch (error) {
      console.error("Failed to fetch Meta lead forms:", error);
    } finally {
      setLoadingForms(false);
    }
  };

  const fetchAgents = async () => {
    setLoadingAgents(true);
    try {
      const response = await api.get("/admin/user/getAgent");
      if (response.data.status === "success") {
        setAgents(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch agents:", error);
    } finally {
      setLoadingAgents(false);
    }
  };

  const handleSelectPageClick = (account) => {
    if (account.isConnected) {
      document.getElementById("open-meta-leadforms-modal")?.click();
    }
  };

  const handleSelectMetaLeadForm = async (form) => {
    // If user is not a company admin, directly import to their account
    if (userProfile?.role !== "companyAdmin") {
      await selectMetaPage(form.id, form.page_id, form.page_access_token, null);
      document.getElementById("close-meta-leadforms-modal")?.click();
      return;
    }

    // Company admin gets the two-step form
    setSelectedForm(form);
    setModalStep(2);
    fetchAgents();
  };

  const handleBackToFormList = () => {
    setModalStep(1);
    setSelectedForm(null);
    setImportType("my_account");
    setSelectedAgent("");
  };

  const handleImportLeads = async () => {
    if (!selectedForm) return;

    const agentId = importType === "agent_account" ? selectedAgent : null;
    await selectMetaPage(
      selectedForm.id,
      selectedForm.page_id,
      selectedForm.page_access_token,
      agentId
    );

    // Reset and close modal
    setModalStep(1);
    setSelectedForm(null);
    setImportType("my_account");
    setSelectedAgent("");
    document.getElementById("close-meta-leadforms-modal")?.click();
  };

  // Group lead forms by page
  const groupFormsByPage = () => {
    const grouped = {};
    metaLeadForms.forEach((form) => {
      const pageName = form.page_name || "Unknown Page";
      const pageId = form.page_id;
      if (!grouped[pageId]) {
        grouped[pageId] = {
          pageName,
          pageId,
          pageAccessToken: form.page_access_token,
          forms: [],
        };
      }
      grouped[pageId].forms.push(form);
    });
    return grouped;
  };

  // Check if a page is subscribed
  const isPageSubscribed = (pageId) => {
    return userProfile?.accounts?.crm
      ?.find((account) => account.type === "meta")
      ?.subscribedPages?.some((page) => page.pageId === pageId);
  };

  // Handle page subscription toggle
  const handlePageSubscriptionToggle = async (
    pageId,
    pageName,
    pageAccessToken
  ) => {
    const isSubscribed = isPageSubscribed(pageId);
    await subscribeToMetaPage(pageId, pageName, pageAccessToken, !isSubscribed);
  };

  // Scroll to and highlight section from setup guide navigation
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const highlight = params.get("highlight");
    if (highlight === "email" || highlight === "crm") {
      setSetupHighlight(highlight);
      setTimeout(() => {
        const el = document.getElementById(`sync-section-${highlight}`);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
      // Clear glow after 4 seconds
      setTimeout(() => setSetupHighlight(null), 4000);
    }
  }, [location.search]);

  // Fetch lead forms when meta lead forms modal is opened
  React.useEffect(() => {
    const modalTrigger = document.getElementById("open-meta-leadforms-modal");
    if (modalTrigger) {
      modalTrigger.addEventListener("click", fetchMetaPages);
      return () => modalTrigger.removeEventListener("click", fetchMetaPages);
    }
  }, []);

  // Reset modal state when closed
  React.useEffect(() => {
    const modalElement = document.getElementById("meta_leadforms_modal");
    if (modalElement) {
      const handleModalHidden = () => {
        setModalStep(1);
        setSelectedForm(null);
        setImportType("my_account");
        setSelectedAgent("");
      };
      modalElement.addEventListener("hidden.bs.modal", handleModalHidden);
      return () =>
        modalElement.removeEventListener("hidden.bs.modal", handleModalHidden);
    }
  }, []);

  console.log(userProfile?.accounts?.crm, "userProfile?.accounts?.crm?");

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                {/* <div className="col-xl-3 col-lg-12 theiaStickySidebar">
                  <div className="card">
                    <div className="card-body">
                      <div className="settings-sidebar">
                        <h4 className="fw-semibold mb-3">Settings</h4>
                        <div className="list-group list-group-flush settings-sidebar">
                          <Link to={route.profile} className="fw-medium">
                            Profile
                          </Link>
                          <Link to={route.security} className="fw-medium">
                            Security
                          </Link>
                          <Link
                            to={route.emailSetup}
                            className="fw-medium active"
                          >
                            Sync and Integration
                          </Link>
                          <Link
                            to={`${route.scans}#myScans`}
                            className="fw-medium"
                          >
                            My Scans
                          </Link>
                          <Link to={route.upgradePlan} className="fw-medium">
                            Upgrade Plan
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="col-xl-12 col-lg-12">
                  <div
                    id="sync-section-email"
                    className={`card${setupHighlight === "email" ? " setup-highlight-glow" : ""}`}
                  >
                    <div className="card-body">
                      <h4 className="fw-semibold mb-3">Email Integrations</h4>
                      <div>
                        <div className="row">
                          {userProfile?.accounts?.email?.map(
                            (account, index) => {
                              const type = account.type.toLowerCase();
                              const isConnected = account.isConnected;

                              return (
                                <div
                                  className="col-md-4 mb-md-0 mb-2 col-sm-6 d-flex"
                                  key={index}
                                >
                                  <div className="card border mb-3 h-100 w-100 pb-0 gradient-border">
                                    <div className="card-body pb-0">
                                      <div className="d-flex align-items-center justify-content-between mb-3">
                                        <ImageWithBasePath
                                          src={`assets/img/${iconMap[type]}`}
                                          width={50}
                                          alt={`${account.type} Icon`}
                                        />
                                        <div className="connect-btn">
                                          <Link
                                            to="#"
                                            className="badge badge-soft-success"
                                          >
                                            {isConnected
                                              ? "Connected"
                                              : "Not Connected"}
                                          </Link>
                                        </div>
                                      </div>

                                      <div className="d-flex align-items-center justify-content-between">
                                        <p className="mb-0 text-capitalize">
                                          {account.type}
                                        </p>
                                        <div className="form-check form-switch">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            checked={account.isConnected}
                                            onChange={() =>
                                              toggleHandlers(account)
                                            }
                                          />
                                        </div>
                                      </div>
                                      {account.email && (
                                        <p className="mb-0 text-muted mt-3">
                                          ({account.email})
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-12 col-lg-12">
                  <div
                    id="sync-section-crm"
                    className={`card${setupHighlight === "crm" ? " setup-highlight-glow" : ""}`}
                  >
                    <div className="card-body">
                      <h4 className="fw-semibold mb-3">CRM Integrations</h4>
                      <div>
                        <div className="row g-4">
                          {userProfile?.accounts?.crm?.filter((a) => a.type.toLowerCase() !== "meta").map((account, index) => {
                            const type = account.type.toLowerCase();
                            const isConnected = account.isConnected;

                            return (
                              <div
                                className="col-md-4 mb-md-0 col-sm-6 d-flex mb-2"
                                key={index}
                              >
                                <div className="card border mb-3 h-100 w-100 pb-0 gradient-border">
                                  <div className="card-body pb-0">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                      <ImageWithBasePath
                                        src={`assets/img/${iconMap[type]}`}
                                        width={50}
                                        alt={`${account.type} Icon`}
                                      />
                                      <div className="connect-btn">
                                        <Link
                                          to="#"
                                          className="badge badge-soft-success"
                                        >
                                          {isConnected
                                            ? "Connected"
                                            : "Not Connected"}
                                        </Link>
                                      </div>
                                    </div>

                                    <div className="d-flex align-items-center justify-content-between">
                                      <p className="mb-0 text-capitalize">
                                        {account.type}
                                      </p>
                                      <div className="form-check form-switch">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          role="switch"
                                          checked={account.isConnected}
                                          onChange={() =>
                                            toggleHandlers(account)
                                          }
                                        />
                                      </div>
                                    </div>
                                    {account.email && (
                                      <p className="mb-0 text-muted mt-3">
                                        ({account.email})
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* ── Social Media Integrations ── */}
                <div className="col-xl-12 col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="fw-semibold mb-3">Social Media Integrations</h4>
                      <div>
                        <div className="row g-4">
                          {userProfile?.accounts?.crm?.filter((a) => a.type.toLowerCase() === "meta").map((account, index) => {
                            const type = account.type.toLowerCase();
                            const isConnected = account.isConnected;

                            return (
                              <div
                                className="col-md-4 mb-md-0 col-sm-6 d-flex mb-2"
                                key={index}
                              >
                                <div className="card border mb-3 h-100 w-100 pb-0 gradient-border">
                                  <div className="card-body pb-0">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                      <ImageWithBasePath
                                        src={`assets/img/${iconMap[type]}`}
                                        width={50}
                                        alt={`${account.type} Icon`}
                                      />
                                      <div className="connect-btn">
                                        <Link
                                          to="#"
                                          className="badge badge-soft-success"
                                        >
                                          {isConnected
                                            ? "Connected"
                                            : "Not Connected"}
                                        </Link>
                                      </div>
                                    </div>

                                    <div className="d-flex align-items-center justify-content-between">
                                      <p className="mb-0 text-capitalize">
                                        {account.type}
                                      </p>
                                      <div className="form-check form-switch">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          role="switch"
                                          checked={account.isConnected}
                                          onChange={() =>
                                            toggleHandlers(account)
                                          }
                                        />
                                      </div>
                                    </div>
                                    {account.email && (
                                      <p className="mb-0 text-muted mt-3">
                                        ({account.email})
                                      </p>
                                    )}
                                    {isConnected && (
                                      <div className="mt-3">
                                        <button
                                          className="btn btn-sm btn-primary w-100"
                                          onClick={() =>
                                            handleSelectPageClick(account)
                                          }
                                        >
                                          Import Leads
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        id="open-disconnect-modal"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#disconnect_google_modal"
        className="d-none"
      />
      <button
        id="open-smtp-modal"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#open_smtp_modal"
        className="d-none"
      />
      <button
        id="open-meta-leadforms-modal"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#meta_leadforms_modal"
        className="d-none"
      />
      <button
        id="disconnect-smtp-modal"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#disconnect_smtp_modal"
        className="d-none"
      />

      <div
        className="modal fade"
        id="disconnect_google_modal"
        tabIndex="-1"
        aria-labelledby="disconnectGoogleLabel"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-theme-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-theme" />
                </div>
                <h4 className="mb-2 text-capitalize">Remove account?</h4>
                <p className="mb-0">
                  Are you sure you want to disconnect <br /> the {modalText}{" "}
                  account
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to={"#"}
                    data-bs-dismiss="modal"
                    className="btn btn-theme text-white"
                    // onClick={() => {
                    //   modalText === "Google"
                    //     ? onGoogleDisconnect()
                    //     : modalText === "Microsoft"
                    //     ? onMicrosoftDisconnect()
                    //     : onSmtpDisconnect();
                    // }}
                    onClick={() => {
                      modalText === "Google"
                        ? onGoogleDisconnect()
                        : modalText === "Microsoft"
                          ? onMicrosoftDisconnect()
                          : modalText === "Zoho"
                            ? onZohoDisconnect()
                            : modalText === "Meta"
                              ? onMetaDisconnect()
                              : modalText === "Zoom"
                                ? onZoomDisconnect()
                                : modalText === "HubSpot"
                                  ? onHubSpotDisconnect()
                                  : modalText === "Pipedrive"
                                    ? onPipedriveDisconnect()
                                    : onSmtpDisconnect();
                    }}
                  >
                    Yes, Remove it
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="open_smtp_modal"
        tabIndex="-1"
        aria-labelledby="smtpModalLabel"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="">
                <h4 className="mb-2 text-capitalize text-center">
                  Connect SMTP
                </h4>
                <div className="col-12">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Host Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="SMTP_HOST"
                      value={formData.SMTP_HOST}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Port Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="SMTP_PORT"
                      value={formData.SMTP_PORT}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Username <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="SMTP_USER"
                      value={formData.SMTP_USER}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Password <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="SMTP_PASS"
                      value={formData.SMTP_PASS}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to={"#"}
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                    onClick={() => {
                      smtpSignIn(formData);
                    }}
                  >
                    Save Info
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Meta Lead Forms Selection Modal */}
      <div
        className="modal fade"
        id="meta_leadforms_modal"
        tabIndex="-1"
        aria-labelledby="metaLeadFormsLabel"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {modalStep === 1 ? "Select Lead Form" : "Import Options"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="close-meta-leadforms-modal"
              />
            </div>
            <div
              className="modal-body"
              style={{
                minHeight: "400px",
                maxHeight: "500px",
                overflow: "hidden",
                position: "relative",
                padding: 0,
              }}
            >
              {/* Step 1: Lead Forms List */}
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  padding: "1.5rem",
                  overflowY: "auto",
                  transition: "transform 0.3s ease-in-out",
                  transform:
                    modalStep === 1 ? "translateX(0)" : "translateX(-100%)",
                  left: 0,
                }}
              >
                {loadingForms ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading your lead forms...</p>
                  </div>
                ) : metaLeadForms.length > 0 ? (
                  <div>
                    <p className="text-muted mb-3">
                      Toggle to subscribe to a page for automatic webhook
                      notifications. Select forms to import existing leads.
                    </p>
                    {Object.entries(groupFormsByPage()).map(
                      ([pageId, pageData]) => {
                        const isSubscribed = isPageSubscribed(pageId);
                        return (
                          <div key={pageId} className="mb-4">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6 className="text-primary mb-0">
                                <i className="ti ti-brand-facebook me-1" />
                                {pageData.pageName}
                              </h6>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={isSubscribed}
                                  onChange={() =>
                                    handlePageSubscriptionToggle(
                                      pageData.pageId,
                                      pageData.pageName,
                                      pageData.pageAccessToken
                                    )
                                  }
                                  title="Subscribe to receive future leads via webhook"
                                />
                                <label className="form-check-label text-muted small">
                                  {isSubscribed
                                    ? "Subscribed"
                                    : "Subscribe for future leads"}
                                </label>
                              </div>
                            </div>
                            <div className="list-group">
                              {pageData.forms.map((form) => (
                                <button
                                  key={form.id}
                                  type="button"
                                  className="list-group-item list-group-item-action"
                                  onClick={() => handleSelectMetaLeadForm(form)}
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                      <h6 className="mb-2">{form.name}</h6>
                                      <small className="text-muted ">
                                        Leads: {form.leads_count || 0}
                                        {form.status && (
                                          <span className="ms-2 badge badge-sm bg-success">
                                            {form.status}
                                          </span>
                                        )}
                                      </small>
                                    </div>
                                    <i className="ti ti-chevron-right" />
                                  </div>
                                </button>
                              ))}
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <p className="text-muted">No lead forms found.</p>
                    <p className="text-muted small">
                      Make sure you have created lead forms in Facebook Ads
                      Manager.
                    </p>
                  </div>
                )}
              </div>

              {/* Step 2: Import Options */}
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  padding: "1.5rem",
                  overflowY: "auto",
                  transition: "transform 0.3s ease-in-out",
                  transform:
                    modalStep === 2 ? "translateX(0)" : "translateX(100%)",
                  left: 0,
                  top: 0,
                }}
              >
                {selectedForm && (
                  <div style={{ maxWidth: "100%" }}>
                    <div className="p-3 bg-light rounded">
                      <h6 className="mb-1">{selectedForm.name}</h6>
                      <small className="text-muted">
                        {selectedForm.leads_count || 0} leads available
                      </small>
                    </div>

                    <h6 className="mb-3 p-4 pb-0 fw-semibold">
                      Import leads to:
                    </h6>

                    <div className=" p-4 ms-3 pt-0">
                      <div className="form-check mb-1 p-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="importType"
                          id="importToMyAccount"
                          value="my_account"
                          checked={importType === "my_account"}
                          onChange={(e) => setImportType(e.target.value)}
                        />
                        <label
                          className="form-check-label ms-2"
                          htmlFor="importToMyAccount"
                        >
                          Import to my account
                        </label>
                      </div>

                      <div className="form-check p-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="importType"
                          id="importToAgent"
                          value="agent_account"
                          checked={importType === "agent_account"}
                          onChange={(e) => setImportType(e.target.value)}
                        />
                        <label
                          className="form-check-label ms-2"
                          htmlFor="importToAgent"
                        >
                          Import to an agent&apos;s account
                        </label>
                      </div>
                    </div>

                    {importType === "agent_account" && (
                      <div className="mb-5">
                        <label className="form-label fw-semibold">
                          Select Agent
                        </label>
                        {loadingAgents ? (
                          <div className="text-center py-2">
                            <div
                              className="spinner-border spinner-border-sm"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading agents...
                              </span>
                            </div>
                          </div>
                        ) : (
                          <select
                            className="form-select"
                            value={selectedAgent}
                            onChange={(e) => setSelectedAgent(e.target.value)}
                          >
                            <option value="">-- Select an agent --</option>
                            {agents.map((agent) => (
                              <option key={agent._id} value={agent._id}>
                                {agent.firstName} {agent.lastName} (
                                {agent.email})
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                    )}

                    <div className="d-flex justify-content-between mt-4">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={handleBackToFormList}
                      >
                        <i className="ti ti-arrow-left me-1" />
                        Back
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleImportLeads}
                        disabled={
                          importType === "agent_account" && !selectedAgent
                        }
                      >
                        <i className="ti ti-download me-1" />
                        Import Leads
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SyncAndIntegration;
